import {locale as proposals_en} from "./en/locale.proposals-reservation";
import {locale as proposals_ru} from "./ru/locale.proposals-reservation";

export const proposals_reservation_dialog = [
  {
    lang: 'en',
    data: proposals_en
  },
  {
    lang: 'ru',
    data: proposals_ru
  },
];

